package horcrux.frontend.common.views.documents.dialogs

import horcrux.common.api.dtos.types.DocumentID
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.utils.eitherWay
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogView
import horcrux.frontend.common.views.documents.DocumentNavigatorMenuOption
import mui.material.AlertColor
import mui.material.DialogContent
import mui.material.DialogContentText
import react.FC
import react.Props

external interface DeleteDocumentDialogProps : Props {
    var showDialogState: BooleanState
    var currentDocumentMetadata: DocumentMetadata
    var onSuccess: (DocumentID) -> Unit
    var globalAppState: GlobalAppState
}

val DeleteDocumentDialog = FC<DeleteDocumentDialogProps> { props ->
    DialogView {
        this.title = DocumentNavigatorMenuOption.DELETE_DOCUMENT.viewName
        this.showDialogState = props.showDialogState
        this.dialogActionsMaybe = listOf(
            DialogAction("Cancel"),
            DialogAction("Delete") { showDialogState, isLoadingState ->
                props.globalAppState.submitBackendAPIRequestAsync { backendClient ->
                    isLoadingState.setTrue()
                    backendClient.deleteDocument(
                        props.currentDocumentMetadata.documentID,
                        props.currentDocumentMetadata.collectionID
                    ).map {
                        props.onSuccess(props.currentDocumentMetadata.documentID)
                        props.globalAppState.updateBanner(AlertColor.info, "Document deleted")
                    }.eitherWay {
                        isLoadingState.setFalse()
                        showDialogState.setFalse()
                    }.bind()
                }
            },
        )
        DialogContent {
            DialogContentText {
                +"Are you sure you want to delete document ${props.currentDocumentMetadata.documentName.betterToString()}?"
            }
        }
    }
}
